import React from "react";
import autobind from "class-autobind";
import {FormGroup} from "../group/index";
import {Button} from "../../button/index";
import DayPicker from "react-day-picker";
import moment, {Moment} from "moment-timezone";
import {FORMATS} from "../../../../common/utils/core/formats";
import styled from "../../../styled";
import { Input } from "../input";

const ClickOutComponent = require("react-onclickout");

interface Props {
  className?: string;
  date: Date;
  displayFormat: string;
  locale: string;
  timezone: string;
  onSelect: (value: { moment: Moment, millis: number, date: string; raw: Date }) => void;
}

interface State {
  dropdown: boolean;
}

const Wrapper = styled("div")<{ active: boolean }>`
  position: relative;
  .dropdown {
    z-index: 2;
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border: 1px solid ${({theme}) => theme.input.border};
    display: ${({active}) => active ? "block" : "none"};
  }
`;

export class DatePicker extends React.Component<Props, State> {

  open: boolean = false;

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      dropdown: false,
    };
  }

  onSelect = (date: Date) => {
    const { timezone, onSelect } = this.props;
    const parsed = moment.tz(date, timezone);
    onSelect({
      moment: parsed,
      millis: parsed.valueOf(),
      date: parsed.format(FORMATS.moment.date),
      raw: date,
    });
  }

  render() {

    const { date, timezone, displayFormat, className } = this.props;

    const { dropdown } = this.state;

    return (
      <Wrapper active={dropdown} className={className}>
        <ClickOutComponent onClickOut={() => {
          this.setState({ dropdown: false });
        }}>
          <Input
            className="no-round"
            readOnly={true}
            value={moment.tz(date, timezone).format(displayFormat)}
            onFocus={() => {
              this.setState({ dropdown: true });
            }}
          />
          <div className="dropdown">
            <DayPicker
              selectedDays={date}
              onDayClick={this.onSelect}
            />
          </div>
        </ClickOutComponent>
      </Wrapper>
    );

  }

}
